import React from "react";
import { Tooltip } from "antd";
import { TooltipPlacement } from "antd/lib/tooltip";
import style from "./index.module.scss";
import { EndExerciseStuInfo } from "service/question";

interface TipStuListProps {
    children: React.ReactNode;
    placement?: TooltipPlacement;
    stuList: EndExerciseStuInfo[];
}

export default function TipStuList({
    stuList,
    children,
    placement = "bottomLeft"
}: TipStuListProps) {
    const overlay = (
        <div>
            {stuList.map(stu => (
                <div className={style.item} key={stu.studentId}>
                    <span>{stu.stuName}</span>
                    <span className={style.num}>{stu.studentId}</span>
                </div>
            ))}
        </div>
    );

    return (
        <Tooltip
            overlay={stuList.length !== 0 && overlay}
            placement={placement}
            className={style.root}
            overlayClassName={style.overlay}>
            {children}
        </Tooltip>
    );
}
